import React, { useState } from 'react';

import { RefreshIcon } from '../assets/RefreshIcon';
import { DashboardTile } from '../component/OnCallDashboard/DashboardTile';

export const OnCallDashboard = () => {
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const handleRefreshAll = () => {
    setRefetchTrigger((prev) => prev + 1);
  };

  const tiles = [
    {
      title: 'Active Pet Plans with Zero Preview Orders',
      endpoint: 'active_pet_plans_with_zero_preview_orders',
    },
    {
      title: 'Active Pet Plans with More Than One Preview Orders',
      endpoint: 'active_pet_plans_with_more_than_one_preview_orders',
    },
    {
      title: 'Cancelled Accounts with Hold Orders',
      endpoint: 'cancelled_accounts_with_hold_orders',
    },
    {
      title: 'Cancelled Accounts with Active Pet Plans',
      endpoint: 'cancelled_accounts_with_active_pet_plans',
    },
    { title: 'Active Accounts with No Orders', endpoint: 'active_accounts_with_no_orders' },
    {
      title: 'Orders Stuck in Pre-Fulfilling States',
      endpoint: 'orders_stuck_in_pre_fulfilling_states',
    },
    { title: 'Orders in Error State', endpoint: 'orders_in_error_state' },
    {
      title: "Orders Where Charged Revenue Doesn't Match with Order Products",
      endpoint: 'orders_where_charged_revenue_doesnt_match_with_order_products',
    },
    {
      title: 'Orders Stuck in Preview State with Past Scheduled Date',
      endpoint: 'orders_stuck_in_preview_state_with_past_scheduled_date',
    },
    {
      title: 'Accounts with a null Default Pricing Model ID',
      endpoint: 'accounts_with_null_default_pricing_model',
    },
    {
      title: "Pets with Name Containing '_'",
      endpoint: 'pets_with_name_containing_underscore',
    },
    {
      title: "Non S&T Accounts Labeled as 'is_staff'",
      endpoint: 'non_staff_accounts_labeled_as_is_staff',
    },
    {
      title: 'Emails with more than 1 Account ID',
      endpoint: 'emails_with_more_than_one_account_id',
    },
    {
      title: 'Orders that Charged before they were Scheduled (after 1/1/2026)',
      endpoint: 'orders_charged_before_scheduled',
    },
    {
      title: 'TECH-REPLACEMENT Discount Code Usage (Filter TECH-REPLACEMENT-0098)',
      endpoint: 'tech_replacement_discount_code_usage',
    },
  ];

  return (
    <div className="min-h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="mx-auto w-full">
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">On-Call Dashboard</h1>
          <button
            onClick={handleRefreshAll}
            className="flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium hover:bg-slate-200 border border-slate-300"
          >
            <RefreshIcon className="h-4 w-4" />
            Refresh All
          </button>
        </div>
        <div className="grid gap-6 grid-cols-2">
          {tiles.map((tile) => (
            <DashboardTile
              key={tile.endpoint}
              title={tile.title}
              endpoint={tile.endpoint}
              refetchTrigger={refetchTrigger}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
